import { render, staticRenderFns } from "./ViewStaffLists.vue?vue&type=template&id=22180575&scoped=true"
import script from "./ViewStaffLists.vue?vue&type=script&lang=js"
export * from "./ViewStaffLists.vue?vue&type=script&lang=js"
import style0 from "./ViewStaffLists.vue?vue&type=style&index=0&id=22180575&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22180575",
  null
  
)

export default component.exports